import { AbilityBuilder, Ability } from '@casl/ability';

// To allow CASL to work with anonymous object we need to change subject detection function
// Either need to detect Object type by its structure or add additional field inside to detect type.
// https://github.com/stalniy/casl/issues/153
function subjectName (subject) {
    if (!subject || typeof subject === 'string') {
        return subject;
    }

    return subject.__caslType;
};

const Admin = AbilityBuilder.define({ subjectName }, can => {
    can('manage', 'Admin');
    can('manage', 'Users');
    can('manage', 'HFMCodes');
    can('manage', 'MetricWeights');
    can('manage', 'Documents');
    can('manage', 'Logs');
    can('manage', 'NetbaseTokens');
    can('manage', 'ProjectOwnership');
    can(['create', 'read', 'update', 'delete'], 'Project');
    can('update', 'ProjectDashboard');
});

const LocalAdmin = AbilityBuilder.define({ subjectName }, can => {
    can('manage', 'Admin');
    can('manage', 'Users');
    can(['create', 'read', 'update', 'delete'], 'Project');
    can('update', 'ProjectDashboard');
});

const PowerUser = AbilityBuilder.define({ subjectName }, can => {
    can(['create', 'read'], 'Project');
    can(['update', 'delete'], 'Project');
    can('update', 'ProjectDashboard');
});

const User = AbilityBuilder.define({ subjectName }, can => {
    can(['read'], 'Project');
});

const Client = AbilityBuilder.define({ subjectName }, can => {
    can('read', 'Project');
});

// Define an empty ability object that uses the custom subjectName() for default/unauthorised users
const Unauthorised = new Ability([], { subjectName });

export default { Admin, LocalAdmin, PowerUser, User, Client, Unauthorised };
